// extracted by mini-css-extract-plugin
export default {"main_wrappper":"StepInfo_main_wrappper__Y56jb","info_icon_wrapper":"StepInfo_info_icon_wrapper__xYBRB","step_info_message":"StepInfo_step_info_message__olEgv"};